<template>
  <section
    class="flex-column d-flex"
    data-cy="application-form-section-credit-trust">
    <div>
      <h5 data-cy="application-form-credit-trust-title">
        {{ $t('message.applicationForm.creditTrust.title') }}
      </h5>
      <span>{{ $t('message.applicationForm.creditTrust.description') }}</span>
      <div
        v-if="individual.address.country && individual.address.country !== 'CH'"
        class="mt-2">
        <h6>{{ $t('message.applicationForm.creditTrust.creditTrustOnlyForSwiss') }}</h6>
      </div>

      <div v-if="(!individual.address.country || individual.address.country === 'CH') && !certificateNoIssuable">
        <div class="mt-2">
          <label for="doYouHaveCertificate">{{ $t('message.applicationForm.creditTrust.doYouHaveCertificate') }}</label>
          <coozzy-form-select
            id="doYouHaveCertificate"
            v-model="doYouHaveCertificate"
            data-cy="application-form-credit-trust-have-certificate-select">
            <option value="null">
              -
            </option>
            <option value="YES">
              {{ $t('message.generic.selectField.yes') }}
            </option>
            <option value="NO">
              {{ $t('message.generic.selectField.no') }}
            </option>
            <option value="NO_DEBT_REGISTER">
              {{ $t('message.applicationForm.creditTrust.noIHaveDebtRegister') }}
            </option>
          </coozzy-form-select>
        </div>
      </div>
    </div>
    <div :class="(verifiedCertificateValid === false && wannaOrderCertificate === 'YES') ? 'moveToOneBeforeLast' : ''">
      <div v-if="(!individual.address.country || individual.address.country === 'CH') && !certificateNoIssuable">
        <div v-if="doYouHaveCertificate === 'NO' || wannaOrderCertificate === 'YES'">
          <div>
            <label for="credit-trust-debt-certificate">{{ $t('message.applicationForm.debtCertificate') }} </label>
            <coozzy-form-select
              id="credit-trust-debt-certificate"
              v-model="debtCertificateLastFiveYears"
              data-cy="application-form-credit-trust-debt-certificate-select">
              <option value="">
                -
              </option>
              <option value="YES">
                {{ $t('message.generic.selectField.yes') }}
              </option>
              <option value="NO">
                {{ $t('message.generic.selectField.no') }}
              </option>
            </coozzy-form-select>
          </div>
          <div
            v-if="debtCertificateLastFiveYears === 'NO' || (wannaOrderCertificate === 'YES' && verifiedCertificateValid !== false)">
            <label for="haveYouMovedLastThreeYears">
              {{ $t('message.applicationForm.creditTrust.haveYouMovedLastThreeYears') }}</label>
            <coozzy-form-select
              id="haveYouMovedLastThreeYears"
              v-model="haveYouMovedLastThreeYears"
              data-cy="application-form-credit-trust-moved-last-three-years-select">
              <option value="null">
                -
              </option>
              <option value="YES">
                {{ $t('message.generic.selectField.yes') }}
              </option>
              <option value="NO">
                {{ $t('message.generic.selectField.no') }}
              </option>
            </coozzy-form-select>
          </div>
          <div
            v-if="haveYouMovedLastThreeYears === 'YES' && debtCertificateLastFiveYears === 'NO'"
            class="row mt-2">
            <div class="col-sm-12 col-md-3">
              <coozzy-form-input
                v-model="streetOld"
                data-cy="application-form-credit-trust-old-street-input"
                :name="$tc('message.generic.street')"
                :state="$v.streetOld.$dirty && $v.streetOld.$error ? false : null" />
            </div>
            <div class="col-sm-12 col-md-3">
              <coozzy-form-input
                v-model="streetNumberOld"
                data-cy="application-form-credit-trust-old-house-number-input"
                :name="$tc('message.generic.streetNumber')"
                :state="$v.streetNumberOld.$dirty && $v.streetNumberOld.$error ? false : null" />
            </div>
            <div class="col-sm-12 col-md-3">
              <coozzy-form-input
                v-model="zipOld"
                data-cy="application-form-credit-trust-old-zip-input"
                :limit="4"
                :name="$tc('message.generic.zip')"
                :state="$v.zipOld.$dirty && $v.zipOld.$error ? false : null"
                @input="getCityFromZip"
                @keydown.tab="isCitiesSuggested ? tabClicked() : ''" />
            </div>
            <div class="col-sm-12 col-md-3">
              <coozzy-form-input
                v-if="!isCitiesSuggested"
                :id="'credit-trust-city-old-' + individualId"
                v-model="cityOld"
                data-cy="application-form-credit-trust-old-city-input"
                :name="$tc('message.generic.city')"
                :state="$v.cityOld.$dirty && $v.cityOld.$error ? false : null"
                type="text" />
              <template v-else>
                <label :for="'credit-trust-city-suggest-' + individualId">{{ $t('message.generic.city') }}*</label>
                <coozzy-form-select
                  :id="'credit-trust-city-suggest-' + individualId"
                  v-model="citySelect"
                  data-cy="application-form-credit-trust-old-city-select"
                  :state="$v.cityOld.$dirty && $v.cityOld.$error ? false : null"
                  @change="cityChanged">
                  <option
                    v-for="(cityOption, cityIndex) in citiesValue"
                    :key="cityIndex"
                    :selected="cityIndex === 0"
                    :value="cityOption">
                    {{ cityOption.city }}
                  </option>
                </coozzy-form-select>
              </template>
            </div>
          </div>
          <coozzy-form-checkbox
            v-if="debtCertificateLastFiveYears === 'NO' && haveYouMovedLastThreeYears && !orderedCertificateValid"
            id="acceptsCreditTrustTerms"
            :key="'acceptsCreditTrustTerms'"
            v-model="acceptsCreditTrustTerms"
            data-cy="application-form-credit-trust-accept-terms-checkbox"
            :initial="acceptsCreditTrustTerms"
            :state="$v.acceptsCreditTrustTerms.$dirty && $v.acceptsCreditTrustTerms.$error ? false : null"
            class="align-self-center mt-3">
            <!-- eslint-disable vue/no-v-html -->
            <div v-html="termsHtml" />
            <!-- eslint-enable vue/no-v-html -->
          </coozzy-form-checkbox>
          <coozzy-form-checkbox
            v-if="debtCertificateLastFiveYears === 'NO' && haveYouMovedLastThreeYears && !orderedCertificateValid"
            id="confirmOrderAndPayment"
            :key="'confirmOrderAndPayment'"
            v-model="confirmOrderAndPayment"
            data-cy="application-form-credit-trust-confirm-order-checkbox"
            :initial="confirmOrderAndPayment"
            :state="$v.confirmOrderAndPayment.$dirty && $v.confirmOrderAndPayment.$error ? false : null"
            class="align-self-center mt-3">
            {{ $t('message.applicationForm.creditTrust.confirmOrderAndPayment') }}
          </coozzy-form-checkbox>
          <coozzy-button
            v-if="!orderCertificateProcessing && debtCertificateLastFiveYears === 'NO' && haveYouMovedLastThreeYears && !orderedCertificateValid"
            ref="orderCertificateButton"
            data-cy="application-form-credit-trust-order-certificate-button"
            :disabled="!confirmOrderAndPayment || !acceptsCreditTrustTerms || errorDuringDownload"
            class="mt-2"
            design="prop-green"
            @click="checkIndividualBasicForOrderCertificate()">
            {{ $t('message.applicationForm.creditTrust.orderCertificate') }}
          </coozzy-button>
          <div
            v-if="errorDuringOrder"
            class="mt-1">
            <span>{{ $t('message.applicationForm.creditTrust.certificateOrderError') }}</span>
          </div>
          <div>
            <coozzy-spinner
              v-if="orderCertificateProcessing"
              class="align-self-center mt-2" />
            <span
              v-if="orderCertificateProcessing"
              style="vertical-align: super;">
              {{ $t('message.applicationForm.creditTrust.orderIsBeingProcessed') }}
            </span>
          </div>
          <div class="mt-2">
            <span v-if="orderedCertificateValid">{{
              $t('message.applicationForm.creditTrust.certificateIssuedAndValid')
            }}</span>
            <span v-if="orderedCertificateValid === false">{{
              $t('message.applicationForm.creditTrust.certificateIssuedAndNotValid')
            }}</span>
          </div>
          <div v-if="orderedCertificateValid">
            <div
              v-for="item in creditTrustCertificateMedia"
              :key="item.id"
              class="media-block col">
              <div
                class="file-block p-1 my-2">
                <a
                  :href="item.url"
                  data-v-09485260=""
                  target="_blank">
                  {{ item.filename }}
                </a>
                <coozzy-button
                  class="delete-icon"
                  design="transparent"
                  data-cy="application-form-credit-trust-delete-ordered-certificate-button"
                  @click="deleteMedia(item.id, 'creditTrustCertificateMediaIds')">
                  <coozzy-delete-icon />
                </coozzy-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="doYouHaveCertificate === 'NO_DEBT_REGISTER' || debtCertificateLastFiveYears === 'YES' || orderedCertificateValid === false || wannaOrderCertificate === 'NO' || (individual.address.country && individual.address.country !== 'CH') || certificateNoIssuable"
      :class="verifiedCertificateValid === false ? 'moveToLast' : ''"
      class="row mt-2">
      <div class="col-12 col-md-12 mt-1 mb-1">
        <span v-if="!certificateNoIssuable">{{
          $t('message.applicationForm.creditTrust.pleaseSubmitDebtEnforcementRegister')
        }}</span>
        <span v-else>{{ $t('message.applicationForm.creditTrust.certificateNoIssuable') }}</span>
      </div>
      <div class="col-12 col-md-6">
        <div>
          <b>{{ $t('message.applicationForm.debtEnforcementRegister') }}</b>
          <coozzy-button
            v-if="!debtEnforcementRegisterMediaIds.length"
            class="float-right"
            design="green"
            data-cy="application-form-credit-trust-upload-debt-register-button"
            @click="uploadDocumentClicked('debtUpload')">
            {{ $t('message.manageDocuments.addDocument') }}
          </coozzy-button>
        </div>
        <coozzy-spinner
          v-if="debtUploadProcessing"
          class="align-self-center" />
        <div
          v-for="item in debtEnforcementRegisterMedia"
          :key="item.id"
          class="media-block col">
          <div
            class="file-block p-1 my-2">
            <a
              :href="item.url"
              data-v-09485260=""
              target="_blank">
              {{ item.filename }}
            </a>
            <coozzy-button
              class="delete-icon"
              design="transparent"
              data-cy="application-form-credit-trust-delete-debt-register-button"
              @click="deleteMedia(item.id, 'debtEnforcementRegisterMediaIds')">
              <coozzy-delete-icon />
            </coozzy-button>
          </div>
        </div>
        <coozzy-form-file-input
          ref="debtUpload"
          v-model="debtUpload"
          accept="text/plain, text/csv, application/pdf, image/*, video/*, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
          class="d-none"
          @change="addFile($event, 'debtEnforcementRegisterMediaIds')" />
      </div>
    </div>
    <div v-if="(!individual.address.country || individual.address.country === 'CH') && !certificateNoIssuable">
      <div
        v-if="doYouHaveCertificate === 'YES' || errorDuringDownload"
        class="mt-3">
        <div
          v-if="errorDuringDownload"
          class="mb-2">
          <span>{{ $t('message.applicationForm.creditTrust.certificateGetError') }}</span>
        </div>
        <div
          v-if="(!verifiedCertificateValid || !creditTrustCertificateMediaIds.length) && !wannaOrderCertificate">
          <coozzy-button
            v-if="!creditTrustCertificateMediaIds.length"
            design="green"
            data-cy="application-form-credit-trust-upload-certificate-button"
            @click="uploadDocumentClicked('creditTrustCertificate')">
            {{ $t('message.manageDocuments.addDocument') }}
          </coozzy-button>
        </div>
        <coozzy-spinner
          v-if="creditTrustCertificateUploadProcessing"
          class="align-self-center mt-2" />
        <div
          v-for="item in creditTrustCertificateMedia"
          :key="item.id"
          class="media-block col">
          <div
            class="file-block p-1 my-2">
            <a
              :href="item.url"
              data-v-09485260=""
              target="_blank">
              {{ item.filename }}
            </a>
            <coozzy-button
              class="delete-icon"
              design="transparent"
              data-cy="application-form-credit-trust-delete-certificate-button"
              @click="deleteMedia(item.id, 'creditTrustCertificateMediaIds')">
              <coozzy-delete-icon />
            </coozzy-button>
          </div>
        </div>
        <coozzy-form-file-input
          ref="creditTrustCertificate"
          v-model="creditTrustCertificate"
          accept="application/pdf"
          class="d-none"
          @change="addFile($event, 'creditTrustCertificateMediaIds')" />
        <div class="mt-2">
          <span v-if="verifiedCertificateValid && creditTrustCertificateMediaIds.length">{{
            $t('message.applicationForm.creditTrust.certificateValid')
          }}</span>
          <span v-if="verifiedCertificateValid === false">{{
            $t('message.applicationForm.creditTrust.certificateNotValid')
          }}</span>
        </div>
        <div
          v-if="verifiedCertificateValid === false && !errorDuringDownload"
          class="mt-2">
          <label for="haveYouMovedLastThreeYears">{{
            $t('message.applicationForm.creditTrust.wannaOrderCertificate')
          }}</label>
          <coozzy-form-select
            id="wannaOrderCertificate"
            v-model="wannaOrderCertificate"
            data-cy="application-form-credit-trust-wanna-order-select">
            <option value="">
              -
            </option>
            <option value="YES">
              {{ $t('message.generic.selectField.yes') }}
            </option>
            <option value="NO">
              {{ $t('message.generic.selectField.no') }}
            </option>
          </coozzy-form-select>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import Vue from 'vue'
import { mapGetters, mapMutations } from 'vuex'
import CoozzyFormSelect from '@/framework/components/form/select/CoozzyFormSelect.vue'
import CoozzyDeleteIcon from '@/framework/components/icons/CoozzyDeleteIcon.vue'
import CoozzyButton from '@/framework/components/button/CoozzyButton.vue'
import CoozzySpinner from '@/framework/components/misc/CoozzySpinner.vue'
import CommonApi from '@/misc/apis/CommonApi'
import { media } from '@/mixins/media'
import CoozzyFormInput from '@/framework/components/form/input/CoozzyFormInput.vue'
import CoozzyFormCheckbox from '@/framework/components/form/checkbox/CoozzyFormCheckbox.vue'
import router from '@/router/router'
import CoozzyFormFileInput from '@/framework/components/form/fileInput/CoozzyFormFileInput.vue'
import { required } from 'vuelidate/lib/validators'
import { validation } from '@/mixins/validation'
import * as Sentry from '@sentry/vue'
import { address } from '@/mixins/address'
import { CredittrustOrderCertificateRequest, TypeDate } from '@/types/api'
import {
  ApplicationFormDocumentMediaRow,
  ApplicationFormIndividual,
  ApplicationFormIndividualBasicCityOption
} from '@/types/models'

type CreditTrustMediaIdField =
  | 'debtEnforcementRegisterMediaIds'
  | 'creditTrustCertificateMediaIds'

const checkedTrue = (value: boolean) => value === true

interface CreditTrustDataState {
  doYouHaveCertificate: string | null
  creditTrustCertificateUploadProcessing: boolean
  creditTrustCertificateMedia: ApplicationFormDocumentMediaRow[]
  creditTrustCertificate: File | null
  haveYouMovedLastThreeYears: string | null
  streetOld: string
  streetNumberOld: string
  cityOld: string
  zipOld: string
  acceptsCreditTrustTerms: boolean
  confirmOrderAndPayment: boolean
  debtCertificateLastFiveYears: string | null
  debtUploadProcessing: boolean
  debtEnforcementRegisterMedia: ApplicationFormDocumentMediaRow[]
  debtUpload: File | null
  orderedCertificateValid: boolean | null
  verifiedCertificateValid: boolean | null
  wannaOrderCertificate: string | null
  orderCertificateProcessing: boolean
  errorDuringOrder: boolean
  errorDuringDownload: boolean
  isCitiesSuggested: boolean
  citySelect: ApplicationFormIndividualBasicCityOption | null
  citiesValue: ApplicationFormIndividualBasicCityOption[]
  certificateNoIssuable: boolean
}

export default Vue.extend({
  name: 'ApplicationFormIndividualCreditTrust',
  components: {
    CoozzyFormFileInput,
    CoozzyFormCheckbox,
    CoozzyFormInput,
    CoozzySpinner,
    CoozzyButton,
    CoozzyDeleteIcon,
    CoozzyFormSelect
  },
  mixins: [validation, media, address],
  props: {
    individualId: {
      type: String,
      required: true
    },
    isBusy: {
      type: Boolean,
      default: false
    }
  },
  data(): CreditTrustDataState {
    return {
      doYouHaveCertificate: null,
      creditTrustCertificateUploadProcessing: false,
      creditTrustCertificateMedia: [],
      creditTrustCertificate: null,
      haveYouMovedLastThreeYears: null,
      streetOld: '',
      streetNumberOld: '',
      cityOld: '',
      zipOld: '',
      acceptsCreditTrustTerms: false,
      confirmOrderAndPayment: false,
      debtCertificateLastFiveYears: null,
      debtUploadProcessing: false,
      debtEnforcementRegisterMedia: [],
      debtUpload: null,
      orderedCertificateValid: null,
      verifiedCertificateValid: null,
      wannaOrderCertificate: null,
      orderCertificateProcessing: false,
      errorDuringOrder: false,
      errorDuringDownload: false,
      isCitiesSuggested: false,
      citySelect: null,
      citiesValue: [],
      certificateNoIssuable: false
    }
  },
  computed: {
    ...mapGetters('applicationForm', ['getIndividualByInternalId']),
    individual(): ApplicationFormIndividual {
      return this.getIndividualByInternalId(this.individualId) as ApplicationFormIndividual
    },
    debtEnforcementRegisterMediaIds: {
      get(): string[] {
        return this.individual.debtEnforcementRegisterMediaIds
          ? this.individual.debtEnforcementRegisterMediaIds
          : []
      },
      set(value: string[]) {
        const ind = this.individual
        ind.debtEnforcementRegisterMediaIds = value
        this.updateIndividual(ind)
      }
    },
    creditTrustCertificateMediaIds: {
      get(): string[] {
        return this.individual.creditTrustCertificateMediaIds
          ? this.individual.creditTrustCertificateMediaIds
          : []
      },
      set(value: string[]) {
        const ind = this.individual
        ind.creditTrustCertificateMediaIds = value
        this.updateIndividual(ind)
      }
    },
    termsHtml(): string {
      return this.$tc('message.applicationForm.creditTrust.acceptTerms')
    }
  },
  watch: {
    doYouHaveCertificate() {
      this.resetData()
    }
  },
  methods: {
    ...mapMutations('applicationForm', ['updateIndividual']),
    async addFile(event: Event, source: CreditTrustMediaIdField) {
      if (source === 'debtEnforcementRegisterMediaIds') {
        this.debtUploadProcessing = true
      } else if (source === 'creditTrustCertificateMediaIds') {
        this.creditTrustCertificateUploadProcessing = true
      }
      const files = await this.getFilesFromEvent(event)
      if (files && files.length > 0) {
        const file = files[0] as File
        if (source === 'debtEnforcementRegisterMediaIds') {
          await this.documentCreated(file, source)
        } else if (source === 'creditTrustCertificateMediaIds') {
          await this.verifyCertificate(file)
        }
      }
      if (source === 'debtEnforcementRegisterMediaIds') {
        this.debtUploadProcessing = false
      } else if (source === 'creditTrustCertificateMediaIds') {
        this.creditTrustCertificateUploadProcessing = false
      }
    },
    uploadDocumentClicked(ref: string) {
      if (!this.readOnly) {
        const comp = this.$refs[ref] as Vue & { $el: HTMLElement }
        const btn = comp.$el.children
        ;(btn[0] as HTMLElement).click()
      }
    },
    deleteMedia(id: string, suffix: CreditTrustMediaIdField) {
      if (suffix === 'debtEnforcementRegisterMediaIds') {
        this.debtEnforcementRegisterMediaIds = this.debtEnforcementRegisterMediaIds.filter(e => e !== id)
        this.debtEnforcementRegisterMedia = this.debtEnforcementRegisterMedia.filter(el => el.id !== id)
      } else {
        this.creditTrustCertificateMediaIds = this.creditTrustCertificateMediaIds.filter(e => e !== id)
        this.creditTrustCertificateMedia = this.creditTrustCertificateMedia.filter(el => el.id !== id)
      }
    },
    readFile(file: File): Promise<string> {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result as string)
        reader.onerror = reject
        reader.readAsDataURL(file)
      })
    },
    async verifyCertificate(document: File) {
      try {
        const dataUrl = await this.readFile(document)
        if (dataUrl.includes('data:application/pdf;base64,')) {
          const verifyCertificateResponse = await CommonApi.verifyCertificate(
            dataUrl.replace('data:application/pdf;base64,', '')
          )
          if (verifyCertificateResponse?.verification?.issuerVerified) {
            this.verifiedCertificateValid = true
            await this.documentCreated(document, 'creditTrustCertificateMediaIds')
          } else {
            this.verifiedCertificateValid = false
            Vue.toasted.show(this.$t('message.applicationForm.creditTrust.certificateNotValid'), { type: 'error' })
          }
        } else {
          Vue.toasted.show(this.$t('message.applicationForm.creditTrust.certificateNotValid'), { type: 'error' })
        }
      } catch (e: unknown) {
        const err = e as { response?: { data?: { message?: string } } }
        if (!err.response?.data?.message?.includes('Certificate was not found')) {
          Sentry.captureException(e)
        }
        this.verifiedCertificateValid = false
        Vue.toasted.show(this.$t('message.applicationForm.creditTrust.certificateNotValid'), { type: 'error' })
      } finally {
        this.creditTrustCertificateUploadProcessing = false
      }
    },
    checkIndividualBasicForOrderCertificate() {
      this.$emit('order-certificate', this.individualId)
    },
    async orderCertificate() {
      if (this.isInvalid() === true) {
        return
      }
      this.orderCertificateProcessing = true
      this.errorDuringOrder = false
      Vue.toasted.show(this.$t('message.applicationForm.creditTrust.orderIsBeingProcessed'), { type: 'success' })
      const currentLanguage = router.app.$store.getters['internationalization/getCurrentLanguage']
      let validatedLanguage
      if (currentLanguage === 'de' || currentLanguage === 'fr') {
        validatedLanguage = currentLanguage
      } else {
        validatedLanguage = 'de'
      }
      const normalizedEmail = this.individual.email.trim().toLowerCase()

      const dob: TypeDate | null = this.individual.dob
        ? {
            day: this.individual.dob.day,
            month: this.individual.dob.month,
            year: this.individual.dob.year
          }
        : {
            day: 0,
            month: 0,
            year: 0
          }
      const data: CredittrustOrderCertificateRequest = {
        affiliateOrderId: '',
        referrerUrl: '',
        subAffiliate: '',
        locale: validatedLanguage,
        firstName: this.individual.firstName,
        lastName: this.individual.lastName,
        email: normalizedEmail,
        street: this.individual.address.street,
        houseNumber: this.individual.address.streetNumber,
        postalCode: parseInt(this.individual.address.zip, 10),
        city: this.individual.address.city,
        oldStreet: this.streetOld || '',
        oldHouseNumber: this.streetNumberOld || '',
        oldPostalCode: this.zipOld ? parseInt(this.zipOld, 10) : 0,
        oldCity: this.cityOld || '',
        dateOfBirth: dob
      }
      let orderCertificateResponse
      try {
        orderCertificateResponse = await CommonApi.orderCertificate(data)
      } catch (e) {
        Sentry.captureException(e)
        Vue.toasted.show(this.$t('message.applicationForm.creditTrust.certificateOrderError'), { type: 'error' })
        this.errorDuringOrder = true
      }

      try {
        if (orderCertificateResponse && orderCertificateResponse.certificateIssuable && orderCertificateResponse.orderId) {
          const getCertificateResponse = await CommonApi.getCertificate(orderCertificateResponse.orderId)
          if (getCertificateResponse) {
            const cleanedArrayBuffer = this.cleanRawArrayBuffer(getCertificateResponse)
            const blob = new Blob([cleanedArrayBuffer], { type: 'application/pdf' })
            const file = new File([blob], 'CreditTrust Zertifikat.pdf')
            await this.documentCreated(file, 'creditTrustCertificateMediaIds')
            this.downloadCertificate(file)
          }
          Vue.toasted.show(this.$t('message.applicationForm.creditTrust.certificateIssuedAndValid'), { type: 'success' })
          this.orderedCertificateValid = true
        } else {
          this.certificateNoIssuable = true
          Vue.toasted.show(this.$t('message.applicationForm.creditTrust.certificateNoIssuable'), { type: 'error' })
        }
      } catch (e) {
        Sentry.captureException(e)
        Vue.toasted.show(this.$t('message.applicationForm.creditTrust.certificateGetError'), { type: 'error' })
        this.errorDuringDownload = true
      }
      this.mediaUploadProcessing = false
      this.debtUploadProcessing = false
      this.idCardUploadProcessing = false
      this.orderCertificateProcessing = false
    },
    cleanRawArrayBuffer(arrayBuffer: ArrayBuffer) {
      // credittrust returns a raw array buffer with extra decoded response after %%EOF
      // such file can not be verified, so let's clean it up
      const bytes = new Uint8Array(arrayBuffer)
      const eofSignature = [0x25, 0x25, 0x45, 0x4F, 0x46] // %%EOF in ASCII

      // Find last %%EOF in raw bytes
      let eofIndex = -1
      for (let i = bytes.length - eofSignature.length; i >= 0; i--) {
        if (eofSignature.every((b, j) => bytes[i + j] === b)) {
          eofIndex = i + eofSignature.length
          break
        }
      }

      if (eofIndex === -1) throw new Error('%%EOF not found in binary content')

      return bytes.slice(0, eofIndex)
    },
    downloadCertificate(file: File) {
      const link = document.createElement('a')
      link.href = URL.createObjectURL(file)
      link.download = 'CreditTrust Zertifikat.pdf'
      document.body.append(link)
      link.click()
      link.remove()
      setTimeout(() => URL.revokeObjectURL(link.href), 7000) // timeout for bigger files
    },
    async documentCreated(document: File, suffix: CreditTrustMediaIdField) {
      const selectedFile = [document]
      const response = await this.uploadMedia(selectedFile)
      if (response && response.length > 0) {
        const uploaded = response[0]
        const mediaRow: ApplicationFormDocumentMediaRow = {
          id: uploaded.id,
          url: uploaded.url,
          filename: uploaded.filename
        }
        if (suffix === 'debtEnforcementRegisterMediaIds') {
          this.debtEnforcementRegisterMediaIds = [
            ...this.debtEnforcementRegisterMediaIds,
            uploaded.id
          ]
          this.debtEnforcementRegisterMedia.push(mediaRow)
        } else {
          this.creditTrustCertificateMediaIds = [
            ...this.creditTrustCertificateMediaIds,
            uploaded.id
          ]
          this.creditTrustCertificateMedia.push(mediaRow)
        }
        this.debtUpload = null
        this.creditTrustCertificate = null
      }
      this.mediaUploadProcessing = false
      this.debtUploadProcessing = false
      this.idCardUploadProcessing = false
    },
    async getCityFromZip() {
      const zip = String(this.zipOld ?? '')
      if (zip.length > 3) {
        const zipData = await this.getZipInfo(zip)
        if (zipData) {
          if (zipData.cities.length > 1) {
            this.isCitiesSuggested = true
            this.citiesValue = zipData.cities as ApplicationFormIndividualBasicCityOption[]
          } else {
            this.isCitiesSuggested = false
            this.$nextTick(() => {
              this.cityOld = zipData.cities[0].city
            })
          }
        }
      }
    },
    tabClicked() {
      if (this.citiesValue.length > 0) {
        this.citySelect = this.citiesValue[0]
        this.cityChanged(this.citiesValue[0])
      }
    },
    cityChanged(event: ApplicationFormIndividualBasicCityOption) {
      this.cityOld = event.city
    },
    isInvalid() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        Sentry.setExtra('validationCreditTrust', this.$v)
        this.scrollToError()
        return true
      }
      return false
    },
    resetData() {
      this.creditTrustCertificateMedia = []
      this.creditTrustCertificate = null
      this.haveYouMovedLastThreeYears = null
      this.streetOld = ''
      this.streetNumberOld = ''
      this.cityOld = ''
      this.zipOld = ''
      this.acceptsCreditTrustTerms = false
      this.confirmOrderAndPayment = false
      this.debtCertificateLastFiveYears = null
      this.debtEnforcementRegisterMedia = []
      this.debtUpload = null
      this.orderedCertificateValid = null
      this.verifiedCertificateValid = null
      this.wannaOrderCertificate = null
      this.debtEnforcementRegisterMediaIds = []
      this.creditTrustCertificateMediaIds = []
      this.errorDuringOrder = false
      this.errorDuringDownload = false
      this.certificateNoIssuable = false
    }
  },
  validations() {
    const base = {
      acceptsCreditTrustTerms: {
        checked: checkedTrue
      },
      confirmOrderAndPayment: {
        checked: checkedTrue
      }
    }
    if (this.haveYouMovedLastThreeYears === 'YES') {
      return {
        ...base,
        streetOld: {
          required
        },
        streetNumberOld: {
          required
        },
        zipOld: {
          required
        },
        cityOld: {
          required
        }
      }
    }
    return base
  }
})
</script>

<style lang="scss" scoped>
.moveToOneBeforeLast {
  order: 1
}

.moveToLast {
  order: 2
}
</style>
